import { Resource as c, API as l } from "@coveo/platform-client";
import { shouldMockBatchAnswer as n } from "../ShouldMockBatchAnswer.js";
import { createMockBatchAnswerRunsListResponse as d, createMockBatchAnswerRunItem as p, createMockBatchAnswerRunResultResponse as h } from "./BatchAnswerEvaluationRuns.mocks.js";
const o = 2e3, u = 10, r = class r extends c {
  list(t, e, s) {
    return n(s?.isMocking) ? new Promise((i) => {
      setTimeout(() => {
        i(
          d(
            s?.nbOfMockEntry ?? u,
            e?.page,
            e?.perPage
          )
        );
      }, o);
    }) : this.api.get(
      this.buildPath(`${r.baseUrl}/${t.evaluationId}/runs`, e)
    );
  }
  create(t, e, s) {
    return n(s?.isMocking) ? new Promise((i) => {
      setTimeout(() => {
        i(p(0));
      }, 200);
    }) : this.api.post(
      `${r.baseUrl}/${t.evaluationId}/runs`,
      e
    );
  }
  delete(t, e) {
    return n(e?.isMocking) ? new Promise((s) => {
      setTimeout(() => {
        s();
      }, o);
    }) : this.api.delete(`${r.baseUrl}/${t.evaluationId}/runs/${t.runId}`);
  }
  updateNotes(t, e, s) {
    return n(s?.isMocking) ? new Promise((i) => {
      setTimeout(() => {
        i();
      }, o);
    }) : this.api.put(
      `${r.baseUrl}/${t.evaluationId}/runs/${t.runId}/notes`,
      e
    );
  }
  results(t, e, s) {
    return n(s?.isMocking) ? new Promise((i) => {
      setTimeout(() => {
        i(
          h(
            u,
            e?.page,
            e?.perPage
          )
        );
      }, o);
    }) : this.api.get(
      this.buildPath(`${r.baseUrl}/${t.evaluationId}/runs/results`, e)
    );
  }
};
r.baseUrl = `/rest/organizations/${l.orgPlaceholder}/answer/v1/evaluations`;
let a = r;
export {
  a as EvaluationRunResource
};
//# sourceMappingURL=BatchAnswerEvaluationRuns.resource.js.map
